import { Label } from "reactstrap";
import TableComponent from "../../../components/TableComponent";
import { useSelector } from "react-redux";
import { HEALTH_APPLICATION_HEADERS } from "./TableHeaders";

const HealthPolicyDetails = (props: any) => {

    const {
        storeCustomerDetailsSearchData,
    } = useSelector((state: any) => state.grievances);

    const tableData = storeCustomerDetailsSearchData?.data ?? [];

    return (
        <>
            <Label>
                <img
                    src={require('../../../assets/img/Back.svg').default}
                    style={{ marginRight: '15px', cursor: 'pointer' }}
                    onClick={() => {
                        props?.setSearchSection(!props?.searchSection);
                        props?.setShowHealthDetails(false);
                    }}
                />
                {props?.getValues('searchHealthMobile') &&
                    <span>Mobile Number: {props?.getValues('searchHealthMobile')}</span>}
                {props?.getValues('searchHealthPolicy') &&
                    <span>Policy Number: {props?.getValues('searchHealthPolicy')}</span>}
            </Label>


            <div className="table-container">
                <TableComponent
                    data={tableData}
                    columnHeaders={HEALTH_APPLICATION_HEADERS}
                    onAction={props?.onTableAction}
                    responsive={false}
                />
            </div>

        </>
    );
};

export default HealthPolicyDetails;